import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { createPack, editPack, showPack } from '~/config/routes';
import List from './List';
import Edit from './Edit';
import Show from './Show';
import New from './New';
import { PackProvider } from './context';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function Pack() {
  return (
    <PackProvider>
      <Switch>
        <Route
          exact
          path={createPack.spec}
          render={(props) => (
            <>
              <Can I="new" a="Packs">
                {() => <New {...props} />}
              </Can>
              <Can not I="new" a="Packs">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={editPack.spec}
          render={(props) => (
            <>
              <Can I="edit" a="Packs">
                {() => <Edit {...props} />}
              </Can>
              <Can not I="edit" a="Packs">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={showPack.spec}
          render={(props) => (
            <>
              <Can I="show" a="Packs">
                {() => <Show {...props} />}
              </Can>
              <Can not I="show" a="Packs">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          render={(props) => (
            <>
              <Can I="list" a="Packs">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="Packs">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </PackProvider>
  );
}
export default Pack;
